export default {
  "chooseLang": "Sprache auswählen",
  "whatsOnMind": "Was denkst du gerade?",
  "bestFood": "Beste Essensläden in der Nähe",
  "orderOnline": "Online bestellen",
  "dineout": "Dineout",
  "popularRestaurants": "Beliebte Restaurants für Online-Bestellungen in der Nähe",
  "sortBy": "Sortieren nach",
  "showMore": "Mehr anzeigen",
  "seeMore": "Mehr sehen",
  "getApp": "Laden Sie die Waseeny-App jetzt herunter!",
  "bestOffers": "Für die besten Angebote und Rabatte, die speziell für Sie zusammengestellt wurden.",
  "privacy": "Datenschutzrichtlinie",
  "terms": "Allgemeine Geschäftsbedingungen",
  "contact": "Kontaktieren Sie uns",
  "setLocation": "Standort festlegen",
  "locationDetected": "Standort erkannt",
  "locationError": "Standort konnte nicht erkannt werden",
  "detecting": "Erkennen",
  "searchPlaceholder": "Suche nach Restaurants, Gerichten...",
  "food": "Essen",
  "orderFoodFromRestaurants": "Bestellen Sie Essen in Ihren Lieblingsrestaurants.",
  "exploreNow": "Jetzt entdecken",
  "discoverFoodTitle": "Entdecken Sie köstliche Essensfreuden online in Ihrer Nähe",
  "discoverFoodText": "Lust auf etwas Leckeres? Entdecken Sie eine Welt kulinarischer Köstlichkeiten direkt an Ihren Fingerspitzen mit Essenslieferungen in meiner Nähe! Egal, ob Sie Lust auf einen herzhaften Burger, frisches Sushi oder eine wohltuende Schüssel Pasta haben, es gibt unzählige Möglichkeiten, Ihre Gelüste zu stillen. Die Bequemlichkeit der Online-Essenslieferung in meiner Nähe ermöglicht es Ihnen, verschiedene Restaurants und Küchen zu erkunden, ohne den Komfort Ihres Zuhauses verlassen zu müssen...",
  "allRightsReserved": "Alle Rechte vorbehalten.",
  "logout": "Abmelden",
  "min": "Min.",
  "loading": "Wird geladen...",
  "error": "Fehler",
  "enterSearchTerm": "Bitte geben Sie einen Suchbegriff ein",
  "welcomeBack": "Willkommen zurück!",
  "loginSubtitle": "Loggen Sie sich ein, um Ihre kulinarische Reise fortzusetzen",
  "emailLabel": "E-Mail",
  "passwordLabel": "Passwort",
  "emailPlaceholder": "Geben Sie Ihre E-Mail ein",
  "passwordPlaceholder": "Geben Sie Ihr Passwort ein",
  "forgotPassword": "Passwort vergessen?",
  "loggingIn": "Einloggen...",
  "continueWithGoogle": "Mit Google fortfahren",
  "dontHaveAccount": "Sie haben noch kein Konto?",
  "signUp": "Registrieren",
  "searchFoodPlaceholder": "Suche nach Restaurants und Essen",
  "signIn": "Anmelden",
  "viewCart": "Warenkorb anzeigen",
  "home": "Startseite",
  "cityName": "Stadtname",
  "delivery": "Lieferung",
  "freeDeliveryPromo": "Kostenlose Lieferung für die erste Bestellung",
  "minOrder": "Mindestbestellwert",
  "change": "Ändern",
  "dineOutAvailable": "Essen vor Ort möglich",
  "reserveTableNow": "Reservieren Sie jetzt Ihren Tisch",
  "callForReservations": "Rufen Sie für Reservierungen an",
  "reserveTable": "Tisch reservieren",
  "dealsForYou": "Angebote für Sie",
  "extraOff": "Zusätzlich 0,50 Rabatt",
  "noCodeRequired": "Kein Code erforderlich | Über 5",
  "searchDishesPlaceholder": "Suche nach Gerichten",
  "popular": "Beliebt",
  "mostOrdered": "Gerade am meisten bestellt",
  "itemInCart": "Artikel im Warenkorb",
  "itemsInCart": "Artikel im Warenkorb",
  "itemAdded": "Artikel zum Warenkorb hinzugefügt!",
  "failedToAdd": "Fehler beim Hinzufügen. Bitte erneut versuchen.",
  "cartEmpty": "Dein Warenkorb ist leer",
  "add": "HINZUFÜGEN",
  "selectDeliveryAddress": "Lieferadresse auswählen",
  "savedAddressFound": "Sie haben eine gespeicherte Adresse an diesem Standort",
  "addNewAddress": "Neue Adresse hinzufügen",
  "addressType": "Adresstyp",
  "homeType": "Zuhause",
  "workType": "Arbeit",
  "otherType": "Andere",
  "addressPlaceholder": "Geben Sie Ihre vollständige Adresse ein (z. B. Hausnummer, Gebäudename, Straße, Viertel)",
  "instructionsPlaceholder": "Lieferanweisungen (optional - z. B. Zweimal an der Tür klingeln)",
  "confirmAddress": "Adresse bestätigen",
  "deliveryAddress": "Lieferadresse",
  "cityLabel": "Stadt",
  "minDelivery": "Min. Lieferung",
  "changeUpper": "ÄNDERN",
  "choosePaymentMethod": "Zahlungsmethode wählen",
  "proceedToPay": "Zur Kasse",
  "billDetails": "Rechnungsdetails",
  "subtotal": "Zwischensumme",
  "standardDelivery": "Standardlieferung",
  "free": "Kostenlos",
  "serviceFee": "Servicegebühr",
  "offerApplied": "Angebot angewendet",
  "off": "Rabatt",
  "grandTotal": "Gesamtsumme",
  "searchingFor": "Suche nach",
  "resultsFor": "Ergebnisse für",
  "noMatchesFound": "Keine Treffer gefunden für",
  "backToHome": "Zurück zur Startseite",
  "restaurants": "Restaurants",
  "freeDelivery": "Kostenlose Lieferung",
  "products": "Produkte",
  "itemsAddedToCart": "Artikel hinzugefügt",
  "deliveryIn": "Lieferung in",
  "orderSummary": "Bestellübersicht",
  "noItemsInCart": "Keine Artikel im Warenkorb",
  "payByUpi": "Mit UPI-App bezahlen",
  "addNewUpi": "Neue UPI-ID hinzufügen",
  "upiSubtitle": "Sie müssen eine registrierte UPI-ID haben",
  "creditDebitCard": "Kredit- oder Debitkarte",
  "addNewCard": "Neue Karte hinzufügen",
  "savePayCards": "Speichern und mit Karten bezahlen",
  "morePaymentOptions": "Weitere Zahlungsoptionen",
  "phonePeGPay": "PhonePe, G Pay & mehr",
  "netBanking": "Online-Banking",
  "selectBanks": "Wählen Sie aus einer Liste von Banken",
  "payOnDelivery": "Zahlung bei Lieferung",
  "codTitle": "Nachnahme (Bar / UPI)",
  "payOnReceive": "Bezahlen Sie, wenn Sie Ihr Essen erhalten",
  "placingOrder": "Bestellung wird aufgegeben...",
  "waitConfirmOrder": "Bitte warten Sie, während wir Ihre Bestellung bestätigen.",
  "waitProcessPayment": "Bitte warten Sie, während wir Ihre Zahlung bearbeiten über",
  "orderConfirmed": "Bestellung bestätigt",
  "orderConfirmedMessage": "Ihre Bestellung wurde erfolgreich bestätigt! Wir bearbeiten sie derzeit und werden Sie in Kürze über den Status informieren.",
  "viewBookingDetails": "Buchungsdetails anzeigen",
  "exploreOtherMenu": "Anderes Menü erkunden",
  "cartEmptyAlert": "Der Warenkorb ist leer. Bitte fügen Sie zuerst Artikel hinzu.",
  "resetPassword": "Passwort zurücksetzen",
  "verifyOtp": "OTP verifizieren",
  "enterEmailReset": "Geben Sie Ihre E-Mail ein, um Ihr Passwort zurückzusetzen",
  "enterOtpMobile": "Geben Sie das an Ihr Handy gesendete OTP ein",
  "enterNewPassword": "Geben Sie Ihr neues Passwort ein",
  "passwordResetSubSuccess": "Ihr Passwort wurde zurückgesetzt",
  "sending": "Wird gesendet...",
  "sendOtp": "OTP senden",
  "enterOtpLabel": "OTP eingeben",
  "verifying": "Wird verifiziert...",
  "resendOtpIn": "OTP erneut senden in",
  "resendOtpBtn": "OTP erneut senden",
  "newPasswordPlaceholder": "Neues Passwort eingeben",
  "resetting": "Wird zurückgesetzt...",
  "passwordResetSuccessMsg": "Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich nun mit Ihrem neuen Passwort anmelden.",
  "backToLogin": "Zurück zum Login",
  "back": "Zurück",
  "passLengthError": "Das Passwort muss mindestens 6 Zeichen lang sein",
  "passMatchError": "Passwörter stimmen nicht überein",
  "orderPlacedOn": "Bestellung aufgegeben am",
  "more": "Mehr",
  "reorder": "Nachbestellen",
  "preparing": "Wird vorbereitet",
  "ongoing": "Laufend",
  "delivered": "Geliefert",
  "orderPlacedSuccess": "Ihre Bestellung wurde erfolgreich aufgegeben",
  "orderIdLabel": "Bestellnummer",
  "totalAmountLabel": "Gesamtbetrag",
  "statusLabel": "Status",
  "trackOrder": "Bestellung verfolgen",
  "redirectingToTracking": "Weiterleitung zur Verfolgung in",
  "seconds": "Sekunden",
  "secureCheckout": "Sicherer Checkout",
  "safePayment": "Sicheres Bezahlen",
  "help": "Hilfe",
  "account": "Konto",
  "paymentMethods": "Zahlungsmethoden",
  "items": "Artikel",
  "total": "Gesamt",
  "onlinePaymentStripe": "Online-Zahlung (Stripe)",
  "cardSubtitle": "Visa, Mastercard, Maestro",
  "giropaySubtitle": "Direkt vom Bankkonto bezahlen",
  "klarnaSubtitle": "Jetzt bezahlen oder später",
  "barzahlung": "Barzahlung bei Lieferung",
  "doorstepPayment": "Bezahlen Sie an der Haustür",
  "selected": "Ausgewählt",
  "payNow": "Jetzt bezahlen",
  "processingTitle": "Wird verarbeitet...",
  "okayOrderLater": "Okay, ich bestelle später",
  "restaurantClosed": "Restaurant derzeit geschlossen",
  "moreItems": "weitere Artikel",
  "pleaseLogInToOrder": "Bitte melden Sie sich an, um Ihre Bestellung aufzugeben",
  "loginRequiredForOrder": "Sie müssen ein Konto haben, um Ihre Lieferadresse zu speichern und die Zahlung sicher abzuschließen.",
  "logInOrCreateAccount": "Anmelden oder Konto erstellen",
  "cartConflictMessage": "Ihr Warenkorb enthält Artikel aus einem anderen Restaurant. Möchten Sie Ihren Warenkorb leeren und diesen Artikel hinzufügen?",
  "adding": "Hinzufügen",
  "toCart": "in den Warenkorb",
  "Call number not available": "Call number not available",
  "Restaurant phone number not available": "Restaurant phone number not available",
  ",": ",",
  "Please fill all mandatory fields and select a location on the map.": "Bitte füllen Sie alle Pflichtfelder aus und wählen Sie einen Standort auf der Karte.",
  "Failed to save address. Please try again.": "Adresse konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  "Rider phone number not available.": "Rider phone number not available.",
  "enterEmailError": "Bitte E-Mail eingeben",
  "enterOtpError": "Bitte OTP eingeben",
  "enterNewPassError": "Bitte neues Passwort eingeben",
  "enterEmailPlaceholder": "E-Mail eingeben",
  "newPassword": "Neues Passwort",
  "confirmPasswordLabel": "Passwort bestätigen",
  "confirmNewPasswordPlaceholder": "Neues Passwort bestätigen",
  "Token not received from backend": "Token not received from backend",
  "Invalid email or password": "Invalid email or password",
  "Google login token missing. Please try clicking the Google button again.": "Google login token missing. Please try clicking the Google button again.",
  "Something went wrong with Google Login": "Something went wrong with Google Login",
  "getStarted": "Loslegen",
  "or": "oder",
  "Support is available 24/7. Please contact us at support@waseeny.com": "Support is available 24/7. Please contact us at support@waseeny.com",
  "No contact number available at the moment.": "No contact number available at the moment.",
  "Reason for cancellation?": "Reason for cancellation?",
  "Order cancelled successfully": "Order cancelled successfully",
  "Why are you requesting a refund?": "Why are you requesting a refund?",
  "Refund request submitted successfully. Admin will review it shortly.": "Refund request submitted successfully. Admin will review it shortly.",
  "session_id": "session_id",
  "Thank you for your rating!": "Danke für Ihre Bewertung!",
  "Please select at least one item or provide a note for the refund.": "Bitte wählen Sie mindestens einen Artikel oder geben Sie eine Notiz für die Rückerstattung an.",
  "Failed to reorder items. Please try again.": "Artikel konnten nicht erneut bestellt werden. Bitte versuchen Sie es erneut.",
  "Maximum 6 images are allowed.": "Maximal 6 Bilder erlaubt.",
  "reordering": "Wird erneut bestellt...",
  "Support is available 24/7. Please contact us at support@waseeny.com or call our hotline.": "Support is available 24/7. Please contact us at support@waseeny.com or call our hotline.",
  "Delivery address is missing. Please go back to checkout.": "Lieferadresse fehlt. Bitte gehen Sie zurück zur Kasse.",
  "Failed to add address": "Adresse konnte nicht hinzugefügt werden",
  "Failed to delete address": "Adresse konnte nicht gelöscht werden",
  "Failed to select address": "Adresse konnte nicht ausgewählt werden",
  "Please enter a valid 6-digit OTP": "Please enter a valid 6-digit OTP",
  "Account deletion request submitted. Our team will contact you for verification.": "Account deletion request submitted. Our team will contact you for verification.",
  "Add money feature coming soon!": "Add money feature coming soon!",
  "oftenOrderedWith": "Wird oft mit bestellt",
  "completeMeal": "Komplettmenü",
  "loginRequired": "Anmeldung erforderlich",
  "loginRequiredSub": "Bitte melden Sie sich an, um fortzufahren",
  "logInNow": "Jetzt anmelden",
  "cancel": "Abbrechen",
  "q": "q",
  "-": "-",
  "recentSearches": "Letzte Suchen",
  "clear": "Löschen",
  "pureVeg": "Vegetarisch",
  "rating": "Bewertung",
  "anyPrice": "Beliebiger Preis",
  "Please enter a valid amount": "Bitte geben Sie einen gültigen Betrag ein",
  "Please enter your Bank User ID": "Bitte geben Sie Ihre Bank-Benutzer-ID ein",
  "Bank transaction failed. Please check your bank status.": "Banktransaktion fehlgeschlagen. Bitte prüfen Sie Ihren Bankstatus.",
  "canvas": "canvas",
  "2d": "2d",
  "link": "link",
  "locality": "locality",
  "administrative_area_level_2": "administrative_area_level_2",
  "administrative_area_level_1": "administrative_area_level_1",
  "country": "country",
  "postal_code": "postal_code",
  "route": "route",
  "sublocality_level_1": "sublocality_level_1",
  "sublocality": "sublocality",
  "street_number": "street_number",
  "Select delivery address": "Lieferadresse auswählen",
  "Choose a saved address or add a new one": "Gespeicherte Adresse wählen oder neue hinzufügen",
  "House / Flat No.": "Haus-/Wohnungsnummer",
  "e.g. Flat 101": "z. B. Wohnung 101",
  "Street / Area": "Straße / Gebiet",
  "e.g. Main Street": "z. B. Hauptstraße",
  "Edit Profile": "Profil bearbeiten",
  "Full Name": "Vollständiger Name",
  "Enter your name": "Namen eingeben",
  "Email Address": "E-Mail-Adresse",
  "Verify Your Changes": "Änderungen bestätigen",
  "Fast Delivery": "Schnelle Lieferung",
  "4.5+": "4.5+",
  "Pure Veg": "Vegetarisch",
  "Offers": "Angebote",
  "Open Now": "Jetzt geöffnet",
  "Relevance": "Relevanz",
  "Delivery Time": "Lieferzeit",
  "Help": "Hilfe",
  "Items": "Artikel",
  "Bill Details": "Rechnungsdetails",
  "Create Your Account": "Konto erstellen",
  "Missing Item": "Fehlender Artikel",
  "Quality Issue / Burnt": "Qualitätsproblem / angebrannt",
  "Spill / Damaged": "Verschüttet / beschädigt",
  "Wrong Item": "Falscher Artikel",
  "Late Delivery": "Späte Lieferung",
  "Other": "Sonstiges",
  "Filters & Sorting": "Filter & Sortierung",
  "Choose Variation": "Variation wählen",
  "Add-ons / Toppings": "Zusätze / Toppings",
  "No Coupons Available": "Keine Gutscheine verfügbar",
  "Something went wrong.": "Etwas ist schiefgelaufen.",
  "orders": "Bestellungen",
  "search": "Suche",
  "profile": "Profil",
  "Checkout": "Checkout",
  "DEFAULT": "STANDARD",
  "Change Map Location": "Kartenstandort ändern",
  "Select Location on Map": "Standort auf Karte auswählen",
  "Selected Location:": "Ausgewählter Standort:",
  "Landmark (Optional)": "Wahrzeichen (Optional)",
  "e.g. Near Apollo Hospital": "z. B. In der Nähe des Apollo-Krankenhauses",
  "Save As": "Speichern unter",
  "Saving...": "Wird gespeichert...",
  "Save Address": "Adresse speichern",
  "Cancel": "Abbrechen",
  "Available Offers & Coupons": "Verfügbare Angebote & Gutscheine",
  "Loading offers...": "Angebote werden geladen...",
  "APPLIED": "ANGEWENDET",
  "APPLY": "ANWENDEN",
  "No coupons available right now.": "Derzeit keine Gutscheine verfügbar.",
  "Item Total": "Artikelsumme",
  "Delivery Fee": "Liefergebühr",
  "Platform Fee": "Plattformgebühr",
  "Tax": "Steuer",
  "Packaging": "Verpackung",
  "Small Cart Fee": "Mindermengenzuschlag",
  "Surge Fee": "Surge-Gebühr",
  "Tip": "Trinkgeld",
  "Discount": "Rabatt",
  "Please log in for order": "Bitte loggen Sie sich ein, um zu bestellen",
  "Remove item": "Artikel entfernen",
  "No Max Limit": "Kein maximales Limit",
  "Up to": "Bis zu",
  "OFF": "RABATT",
  "Special offer for you!": "Spezielles Angebot für Sie!",
  "Apna Resto": "Apna Resto",
  "Near": "In der Nähe von",
  "Select City": "Stadt auswählen",
  "Choose a city...": "Wähle eine Stadt...",
  "Loading cities...": "Städte werden geladen...",
  "No cities available": "Keine Städte verfügbar",
  "Address not specified": "Adresse nicht angegeben",
  "Order failed": "Bestellung fehlgeschlagen",
  "Loading Payment details...": "Zahlungsdetails werden geladen...",
  "100% Secure Transaction": "100% sichere Transaktion",
  "Debit/Credit Card / KLARNA": "Debit-/Kreditkarte / KLARNA",
  "Secure payment via Stripe": "Sichere Zahlung über Stripe",
  "Select Payment Method": "Zahlungsmethode auswählen",
  "Order Tracking": "Bestellungsverfolgung",
  "Help": "Hilfe",
  "No orders found.": "Keine Bestellungen gefunden.",
  "Rate your Experience": "Bewerten Sie Ihre Erfahrung",
  "Tell us more about the food and delivery...": "Erzählen Sie uns mehr über das Essen und die Lieferung...",
  "Submitting...": "Wird übermittelt...",
  "Submit Rating": "Bewertung abschicken",
  "Request Item-Level Refund": "Rückerstattung für einzelne Artikel anfordern",
  "Select the items that had issues and provide details.": "Wählen Sie die Artikel mit Problemen aus und geben Sie Details an.",
  "No specific items found. Full order refund will be requested.": "Keine spezifischen Artikel gefunden. Eine Rückerstattung der gesamten Bestellung wird angefordert.",
  "Additional Note / Reason": "Zusätzliche Anmerkung / Grund",
  "Describe the issue in detail...": "Beschreiben Sie das Problem im Detail...",
  "Evidence Images (Optional, Max 6)": "Nachweisbilder (Optional, max. 6)",
  "Click to select photos": "Klicken, um Fotos auszuwählen",
  "Supports PNG, JPG, JPEG (Max 6 files)": "Unterstützt PNG, JPG, JPEG (Max. 6 Dateien)",
  "Submit Refund": "Rückerstattung beantragen",
  "Rate Order": "Bestellung bewerten",
  "Refund Request": "Rückerstattung anfordern",
  "cancelled": "Storniert",
  "Profile": "Profil",
  "Menu": "Menü",
  "Call Rider": "Fahrer anrufen",
  "Call Restaurant": "Restaurant anrufen",
  "Your food is being prepared fresh!": "Ihr Essen wird frisch zubereitet!",
  "Paid Amount": "Bezahlter Betrag",
  "Hurray! You saved": "Hurra! Sie haben gespart",
  "on this order": "bei dieser Bestellung",
  "Track": "Verfolgen",
  "Payment Method": "Zahlungsmethode",
  "Payment Details": "Zahlungsdetails",
  "On": "Am",
  "at": "um",
  "Cancel Order": "Bestellung stornieren",
  "Failed to request refund": "Rückerstattungsantrag fehlgeschlagen",
  "Re-request Refund": "Rückerstattung erneut anfordern",
  "Report Problem / Request Refund": "Problem melden / Rückerstattung anfordern",
  "Refund Request Pending Admin Approval": "Rückerstattungsantrag wartet auf Genehmigung durch den Administrator",
  "Refund Completed": "Rückerstattung abgeschlossen",
  "topBrandsIn": "Top-Marken in",
  "yourArea": "Ihrer Region",
  "filters": "Filter",
  "fastDelivery": "Schnelle Lieferung",
  "offers": "Angebote",
  "openNow": "Jetzt geöffnet",
  "sortRelevance": "Sortieren: Relevanz",
  "sortDeliveryTime": "Sortieren: Lieferzeit",
  "sortRating": "Sortieren: Bewertung",
  "sortCostLowToHigh": "Sortieren: Preis ↑",
  "sortCostHighToLow": "Sortieren: Preis ↓",
  "noRestaurantsMatchFilters": "Keine Restaurants entsprechen Ihren Filtern",
  "clearFilters": "Filter löschen",
  "noRestaurantsNearby": "Keine Restaurants in der Nähe verfügbar",
  "noRestaurantsNearbyDesc": "Wir konnten derzeit keine Restaurants in der Nähe Ihres aktuellen Standorts finden. Versuchen Sie, Ihren Standort zu ändern oder schauen Sie in Kürze wieder vorbei.",
  "quickFilters": "Schnellfilter",
  "fastDeliveryLimit": "Schnelle Lieferung (<30 Min.)",
  "offersBogoFree": "Angebote (1+1 gratis, kostenlose Lieferung)",
  "newRestaurants": "Neue Restaurants",
  "4.5+": "4.5+",
  "4.0+": "4.0+",
  "foodType": "Essensart",
  "Veg": "Vegetarisch",
  "Non-Veg": "Nicht-vegetarisch",
  "Vegan": "Vegan",
  "costRange": "Preisklasse",
  "Low (₹)": "Niedrig (₹)",
  "Medium (₹₹)": "Mittel (₹₹)",
  "High (₹₹₹)": "Hoch (₹₹₹)",
  "clearAll": "Alles löschen",
  "applyFilters": "Filter anwenden",
  "Rating": "Bewertung",
  "Cost Low to High": "Preis: Niedrig bis Hoch",
  "Cost High to Low": "Preis: Hoch bis Niedrig",
  "exclusiveDeals": "EXKLUSIVE ANGEBOTE",
  "todaysOffers": "Heute Angebote",
  "trendingThisWeek": "Diese Woche beliebt",
  "whyChooseWaseeny": "Warum Waseeny wählen?",
  "fastestDelivery": "Schnellste Lieferung",
  "fastestDeliveryDesc": "Ihre Speisen werden in kürzester Zeit frisch und heiß geliefert.",
  "securePayments": "Sichere Zahlungen",
  "securePaymentsDesc": "Wir akzeptieren alle gängigen Kreditkarten und Online-Zahlungsmethoden.",
  "qualityFood": "Hochwertige Speisen",
  "qualityFoodDesc": "Wir arbeiten mit den besten Restaurants zusammen, um Qualität zu gewährleisten.",
  "noTrendingRestaurants": "Keine angesagten Restaurants gefunden.",
  "dish": "Gericht"
};